import { VideoRequestParams } from './interfaces/videoRequest'
import getMarketTrackingProperties from './utils/getMarketTrackingProperties'
import getVideoRequestAnalyticsProperties from './utils/getVideoRequestAnalyticsProperties'

const trackVideoRequestShared = async (
  paramaters: VideoRequestParams,
): Promise<void> => {
  const { request } = paramaters

  const { videoRequestShared } = await import('./sdk')
  videoRequestShared({
    ...getVideoRequestAnalyticsProperties(request),
    ...getMarketTrackingProperties(),
    isBoughtByVisitor: false,
  })
}

export default trackVideoRequestShared
